module.exports = __webpack_public_path__ + "img/rating_3.8bf56901.png";